export type RuntimeConfig = Partial<{
  VITE_API_BASE_URL: string;
  VITE_API_PORT: string;
  VITE_BASE_URL: string;
  VITE_BASE_PATH: string;
  VITE_CLIENT_URL: string;
  VITE_SENTRY_DSN_BACKOFFICE: string;
  VITE_ACUBE_ADE_APPOINTEE_FISCAL_CODE: string;
  VITE_ALLOW_WEAK_PASSWORDS: string;
  VITE_APP_ENV: string;
}>;

declare global {
  interface Window {
    __PREVIXIO_RUNTIME_CONFIG__?: RuntimeConfig;
  }
}

const buildTimeConfig: RuntimeConfig = {
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  VITE_API_PORT: import.meta.env.VITE_API_PORT,
  VITE_BASE_URL: import.meta.env.VITE_BASE_URL,
  VITE_BASE_PATH: import.meta.env.VITE_BASE_PATH,
  VITE_CLIENT_URL: import.meta.env.VITE_CLIENT_URL,
  VITE_SENTRY_DSN_BACKOFFICE: import.meta.env.VITE_SENTRY_DSN_BACKOFFICE,
  VITE_ACUBE_ADE_APPOINTEE_FISCAL_CODE: import.meta.env
    .VITE_ACUBE_ADE_APPOINTEE_FISCAL_CODE,
  VITE_ALLOW_WEAK_PASSWORDS: import.meta.env.VITE_ALLOW_WEAK_PASSWORDS,
  VITE_APP_ENV: import.meta.env.VITE_APP_ENV,
};

const runtimeOverrides =
  typeof window === 'undefined' ? {} : window.__PREVIXIO_RUNTIME_CONFIG__;

export const runtimeConfig = Object.freeze({
  ...buildTimeConfig,
  ...runtimeOverrides,
});

export function resolveRuntimeBasePath(): string {
  const basePath = runtimeConfig.VITE_BASE_PATH?.trim() || '/backoffice';
  const normalized = `/${basePath.replace(/^\/+|\/+$/g, '')}`;
  return normalized === '/' ? '' : normalized;
}
